<script>
	import ProfilePicture from './ProfilePicture.svelte';

	export let src = '';
	export let userName = '';
	export let size;
	export let highlight = false;
	export let truncate = false;
</script>

<div class="iconAndNameWrapper" class:highlight>
	<div class="icon-wrapper">
		<ProfilePicture {userName} {size} fontSize="12" {src} />
	</div>
	<div class="name-wrapper">
		<p class="name" class:truncate>
			{userName}
		</p>
	</div>
</div>

<style>
	.iconAndNameWrapper {
		display: flex;
		justify-content: center;
		align-items: center;
		background: rgba(255, 255, 255, 0.24);
		border-radius: 2.13211e6px;
		width: max-content;
		height: 26px;
		color: rgba(51, 51, 51, 1);
		font-weight: 500;
		/* position: absolute; */
		border-radius: 200px;
	}

	.icon-wrapper {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-left: 5px;
	}

	.name {
		font-size: 11px;
		margin-left: 5px;
		margin-right: 5px;
	}

	.highlight {
		background: #6c44a8;
		color: rgba(255, 255, 255, 1);
	}

	.truncate {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		max-width: 10ch;
	}
</style>
